
<v-row justify="center">
  <v-col v-for="(person, index) in persons" cols="auto" @click="onSelect(index)">
    <v-sheet class="personContainer" elevation="5" rounded>
      <div :style="{backgroundImage: 'url(' + getImageUrl(getPersonPreviewImage(person).smallUrl) + ')'}"
           class="imageContainer"></div>
      <div class="codeContainer">
        <p class="code">{{ person.code }}</p>
      </div>
    </v-sheet>
  </v-col>
</v-row>
